<ion-text>
  <p class="font-text">
    O prazo para a assinatura do contrato expirou.
  <p class="font-text">
    <span class="text-link" (click)="navegarParaAssinaturaDoContrato()">Clique aqui</span> para gerar um novo contrato e
    reiniciar o processo de assinatura.
  </p>
</ion-text>
